import { css } from '@emotion/css';

const style = {
  searchOverlay: css`
    width: calc(100% - 1px);
    z-index: 1 !important;
    .ant-dropdown-arrow {
      top: 6px;
      left: 32px;
    }
    .ant-dropdown-menu {
      flex: 1;
      height: 100%;
      padding: 0;
      box-shadow: none;
    }
  `,
  searchWrap: css`
    overflow: auto;
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: #515359;
    }
    .ant-tabs-ink-bar {
      background: #515359;
    }
    .ant-tabs-tab {
      padding: 2px 0 6px !important;
      .ant-tabs-tab-btn {
        font-size: 12px;
        color: #84868c;
      }
    }
    .ant-tabs-tab + .ant-tabs-tab {
      margin: 0 0 0 16px;
    }
    .ant-tabs-nav {
      margin-bottom: 4px;
    }
    .ant-tabs-content {
      flex-direction: column;
    }
  `,

  searchIptWrap: css`
    display: flex;
    align-items: center;
    border-bottom: solid 1px #f0f2f5;
  `,
  searchIpt: css`
    display: flex;
    align-items: center;
    flex: 1 0 0;
    margin: 8px 12px;
    > div {
      padding-top: 4px;
      font-size: 12px;
      color: #f05b5b;
    }
    .ant-input-group-addon {
      background-color: transparent;
    }
    .ant-input-affix-wrapper-sm {
      padding: 2px 6px;
    }
    .ant-select-selector {
      max-width: 76px;
      font-size: 12px;
      padding: 0 4px !important;
    }
    .ant-select-arrow {
      padding-left: 4px;
    }
    .anticon-close-circle {
      font-size: 12px;
      color: #00000040;
      cursor: pointer;
    }
    .ant-input::placeholder {
      font-size: 12px;
    }
  `,

  tabs: css`
    flex-direction: column;
    height: 100%;
    .ant-tabs-content {
      height: 100%;
    }
    .ant-tabs-tabpane {
      height: 100%;
      overflow: hidden;
    }
  `,

  recentSearchWrap: css`
    padding: 2px;
    overflow: auto;
  `,
  recentSearch: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  recentSearchTags: css`
    margin: 8px;
    .ant-tag {
      cursor: pointer;
      margin-bottom: 8px;
    }
  `,

  hide: css`
    display: none;
  `,

  listWrap: css`
    padding: 8px 4px 0 8px;
    height: 100%;

    .ant-spin-nested-loading,
    .ant-spin-container {
      height: 100%;
    }
  `,
  listWrapAll: css`
    height: 100%;
    padding-right: 4px;
    overflow: auto;
  `,
  searchItem: css`
    border: 1px solid #d3d7e0;
    border-radius: 4px;
    padding: 4px 8px;
    margin-bottom: 8px;
    cursor: pointer;
    &.on {
      background-color: #f0f2f5;
    }
  `,
  titleWrap: css`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 4px;
    overflow: hidden;
    > span {
      flex: 0 0 auto;
      width: 76px;
      font-size: 12px;
      color: #b5b9bf;
    }
    > div {
      flex: 1 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
      > * {
        flex: 0 1 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  `,
  buyerNick: css`
    color: #84868c;
  `,
  storeName: css`
    margin: 1px 4px 0 0;
    color: #515359;
    border-color: #d3d7e0;
    line-height: 16px;
    height: 20px;
    max-width: 100%;
  `,
  daren: css`
    border: none;
    background: #ebfaf3;
    color: #00bf69;
    font-size: 12px;
    line-height: 18px;
    height: 18px;
  `,
  contentWrap: css`
    display: flex;
  `,
  txtHide: css`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `,
  content: css`
    color: #84868c;
  `,
  typeTip: css`
    color: #515359;
    margin-right: 8px;
    word-break: keep-all;
  `,

  typeBar: css`
    color: #515359;
    margin-bottom: 4px;
  `,
  allTypeWrap: css`
    margin-bottom: 12px;
  `,
  lookmore: css`
    width: 100%;
    color: #515359;
    background-color: #f0f2f5;
    &:hover {
      background-color: #f0f2f5;
    }
    &:focus,
    &:hover {
      background-color: #f0f2f5;
      color: #515359;
    }
  `,
  specialTypeContainer: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    > span {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      padding: 0 8px;
      border-bottom: solid 1px #ded7e0;
      > div {
        font-size: 12px;
        color: #f05b5b;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    > div {
      flex: 1 0 0;
    }
  `,
  specialType: css`
    padding: 0 8px;
    overflow-y: auto;
  `,

  wordHighLight: css`
    color: #5b84ff;
  `,
  batchSearch: css`
    display: flex;
    align-items: center;
    > div {
      flex: 1 0 0;
      position: relative;
      > textarea {
        padding: 4px 44px 4px 60px;
        resize: none;
      }
      > section {
        position: absolute;
        top: 1px;
        left: 1px;
        z-index: 1;
        > .ant-select {
          max-width: 80px;
          .ant-select-selector {
            height: 30px;
            border-top: none;
            border-left: none;
            border-bottom: none;
          }
        }
      }
      > .anticon-close-circle {
        position: absolute;
        top: 8px;
        right: 30px;
        color: #00000040;
        cursor: pointer;
      }
      > .ant-btn-text {
        position: absolute;
        top: 4px;
        right: 0;
      }
    }
  `,
  listBar: css`
    display: flex;
    align-items: center;
    padding: 4px 0;
    > div {
      font-size: 12px;
      color: #84868c;
    }
  `,
};

export default style;
